var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderActivityDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.00003C19.9924 4.80662 19.9288 4.61959 19.817 4.46161C19.7052 4.30363 19.5499 4.1815 19.37 4.11003L10.51 0.22003C10.189 0.0920213 9.83104 0.0920213 9.51 0.22003L0.63 4.11003C0.450122 4.1815 0.29485 4.30363 0.183021 4.46161C0.0711927 4.61959 0.00761437 4.80662 0 5.00003V15.12C0.00761437 15.3134 0.0711927 15.5005 0.183021 15.6585C0.29485 15.8164 0.450122 15.9386 0.63 16.01L9.49 19.89C9.64755 19.9595 9.81783 19.9953 9.99 19.9953C10.1622 19.9953 10.3324 19.9595 10.49 19.89L19.37 16C19.5676 15.9219 19.7353 15.7829 19.8485 15.6031C19.9618 15.4233 20.0149 15.212 20 15V5.00003ZM10 2.18003L16.43 5.00003L10 7.82003L3.57 5.00003L10 2.18003ZM2 6.49003L9 9.56003V17.5L2 14.43V6.49003ZM11 17.49V9.56003L18 6.49003V14.43L11 17.49Z",
    fill: "#0F1621"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderActivityDelivery);
export default __webpack_public_path__ + "static/media/order-activity-delivery.dc02864948723ec217154315dfea8057.svg";
export { ForwardRef as ReactComponent };